export default __webpack_public_path__ + "static/media/carouselTest.56c6755a.png";